/**
 * Mirrors the ERP frontend error pattern: extract the backend message
 * when present, fall back to a human-readable context label, and build
 * snackbar options that persist the error + expose the requestId for
 * Sentry correlation.
 */

export function getErrorMessage(err, fallback = 'Une erreur est survenue') {
    const serverMessage = err?.response?.data?.error || err?.response?.data?.message;
    if (serverMessage) return serverMessage;
    if (err?.message && err.message !== 'Network Error') return err.message;
    if (err?.message === 'Network Error') return 'Problème de connexion. Vérifiez votre internet.';
    return fallback;
}

export function getRequestId(err) {
    return err?.response?.data?.requestId || null;
}

/**
 * Snackbar options for notistack. Persist = true so the user can copy
 * the requestId when support asks for it. Provides a Close + Copy
 * button.
 */
export function buildErrorSnackbarOptions(err, closeSnackbar) {
    const requestId = getRequestId(err);
    return {
        variant: 'error',
        persist: true,
        action: (snackKey) => {
            return (
                <>
                    {requestId ? (
                        <button
                            type="button"
                            onClick={() => {
                                navigator.clipboard?.writeText(requestId);
                            }}
                            style={{
                                background: 'transparent',
                                color: 'inherit',
                                border: '1px solid rgba(255,255,255,0.6)',
                                borderRadius: 3,
                                padding: '2px 8px',
                                marginRight: 8,
                                cursor: 'pointer',
                                fontSize: 12,
                                fontFamily: 'inherit',
                            }}
                        >
                            Copier ID
                        </button>
                    ) : null}
                    <button
                        type="button"
                        onClick={() => closeSnackbar(snackKey)}
                        style={{
                            background: 'transparent',
                            color: 'inherit',
                            border: '1px solid rgba(255,255,255,0.6)',
                            borderRadius: 3,
                            padding: '2px 8px',
                            cursor: 'pointer',
                            fontSize: 12,
                            fontFamily: 'inherit',
                        }}
                    >
                        Fermer
                    </button>
                </>
            );
        },
    };
}

/**
 * Identify a price-drift conflict response so pages can show a custom
 * dialog instead of a toast.
 */
export function isPriceDriftError(err) {
    return err?.response?.status === 409 && err?.response?.data?.code === 'PRICE_DRIFT';
}
